import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

const AddContestPage = ({ onClose, onSubmit }) => {
  const [ContestData, setContestData] = useState({
    contest_title: '',
    contest_description: '',
    contest_last_date_to_apply: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    // Optional: You can add code to fetch data like `lom_name`, `program_name`, and `category` for dropdowns here if needed.
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setContestData({ ...ContestData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // POST request to your backend to create a new Contest
      const response = await axios.post('/contests/create', ContestData);
      console.log('Contest added:', response.data);

      Swal.fire({
        icon: 'success',
        title: 'Contest Added',
        text: 'The Contest has been added successfully!',
        confirmButtonText: 'Okay',
      });

      onSubmit(); // Refresh Contests after successful addition
      onClose(); // Close the Add Contest popup
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to add Contest');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg w-full max-w-lg shadow-lg">
        <h2 className="text-lg font-bold mb-4">Add New Contest</h2>
        {error && <p className="text-red-500">{error}</p>}
        <form onSubmit={handleSubmit}>
          {/* LOM Name Dropdown */}
          {/* <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">LOM Name</label>
            <select
              name="lom_name"
              value={ContestData.lom_name}
              onChange={handleChange}
              className="w-full p-2 border rounded-lg"
              required
            >
              <option value="">Select LOM Name</option>
              <option value="general">General</option>
              <option value="lom2">LOM 2</option>
              <option value="lom3">LOM 3</option>
            </select>
          </div> */}

          {/* Program Name Input */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Title</label>
            <input
              type="text"
              name="contest_title"
              value={ContestData.contest_title}
              onChange={handleChange}
              className="w-full p-2 border rounded-lg"
              required
            />
          </div>

          {/* Category Dropdown */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
            <input
              type="text"
              name="contest_description"
              value={ContestData.contest_description}
              onChange={handleChange}
              className="w-full p-2 border rounded-lg"
              required
            />
          </div>

          {/* Contest Date */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Last Date To Apply</label>
            <input
              type="date"
              name="contest_last_date_to_apply"
              value={ContestData.contest_last_date_to_apply}
              onChange={handleChange}
              className="w-full p-2 border rounded-lg"
              required
            />
          </div>


          {/* Action buttons */}
          <div className="flex justify-end space-x-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-300 text-black rounded-lg"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-500 text-white rounded-lg"
              disabled={loading}
            >
              {loading ? 'Adding...' : 'Add Contest'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddContestPage;
